

























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { firebaseDB } from '@/firebase';
import moment from 'moment-timezone';

library.add(faPencilAlt);

export interface ILocalDataField {
  key: string;
  label: string;
  sortable?: boolean;
  class?: string;
}

export class LocalDataField implements ILocalDataField {
  public key: string = '';
  public label: string = '';
  public sortable?: boolean = true;
  public class?: string = '';

  constructor(localDataField?: ILocalDataField) {
    if (localDataField) {
      this.key = localDataField.key ? localDataField.key : '';
      this.label = localDataField.label ? localDataField.label : '';
      this.sortable =
        localDataField.sortable || localDataField.sortable === undefined;
      this.class = localDataField.class
        ? localDataField.class
        : 'text-center text-nowrap';
    }
  }
}

// @ts-ignore
@Component()
export default abstract class LocalDataTable<T> extends Vue {
  // PROPS
  @Prop(String) collectionName!: string;
  @Prop(Array) fieldsSet!: Array<LocalDataField>;
  @Prop({
    type: Boolean,
    default: true
  })
  showSearchBar!: boolean;
  @Prop(Number) perPage?: number;
  @Prop(String) sortBy?: string;
  @Prop(String) sortOrder?: string;
  @Prop({ default: 'ID' })
  primaryKey!: string;
  @Prop({ type: Boolean, default: false })
  isUser!: boolean;

  filterOptions = {
    adminType: [
      { text: 'All', value: '' },
      { text: 'Admin', value: 'Admin' },
      { text: 'Marketing', value: 'Marketing' },
      { text: 'Operation', value: 'Operation' },
      { text: 'Finance', value: 'Finance' },
      { text: 'Management', value: 'Management' },
      { text: 'Call Center', value: 'Call Center' },
      { text: 'Merchant OPS', value: 'Merchant OPS' },
      { text: 'Merchant MKT', value: 'Merchant MKT' },
      { text: 'Runner', value: 'Runner' }
    ]
  };

  /**
   * Function to map data from firestore
   */
  abstract createItem(
    dataSnapshot: firebase.firestore.QueryDocumentSnapshot
  ): T;

  // DATA
  protected currentPage: number = 1;
  protected totalRows: number = 0;

  protected perPageProp: number = this.perPage
    ? this.perPage
    : this.$store.state.defaultPerPage;

  protected sortByProp: string = this.sortBy ? this.sortBy : '';
  protected sortOrderProp: string = this.sortOrder ? this.sortOrder : 'desc';

  protected items: T[] = [];
  protected filterItems: T[] = [];
  protected searchItem: any[] = [];

  protected isLoading: boolean = true;

  protected searchKeyword: string = '';
  protected fieldsFilter: any = {};

  // MOUNTED
  mounted() {
    this.getDataSnapshot();
  }

  // watch
  @Watch('fieldsFilter', { deep: true })
  watchfieldsFilter(value: any, oldValue: any) {
    this.items = this.filterItems.filter((schedule, i) => {
      for (let val in value) {
        if (value[val]) {
          if (val === 'CreatedAt') {
            let createdDate = moment
              .unix(schedule[val])
              .format('dddd[,] DD MMMM YYYY');
            if (createdDate.indexOf(value[val]) !== -1) {
              this.searchItem.push('1');
            } else {
              return false;
            }
          } else {
            if (schedule[val].indexOf(value[val]) !== -1) {
              this.searchItem.push('1');
            } else {
              return false;
            }
          }
        }
      }
      if (this.searchItem.includes('1')) {
        return true;
      }
    });
  }

  // resets all the data
  resetFilter() {
    this.fieldsFilter = {};
    this.getDataSnapshot();
  }

  limitPaging(page, total) {
    if (page < 6) {
      return 7;
    }
    if (page > Math.ceil(total / this.perPageProp) - 5) {
      return 7;
    }
    return 5;
  }

  // METHOD
  getDataSnapshot() {
    this.isLoading = true;
    const collection = firebaseDB
      .collection(this.collectionName)
      .orderBy(this.primaryKey, 'desc');
    collection.onSnapshot(snapshot => {
      this.totalRows = snapshot.size;
      this.filterItems = [];
      this.items = [];
      snapshot.forEach(item => {
        this.filterItems.push(this.createItem(item));
      });
      this.items = this.filterItems;
      this.isLoading = false;
    });
  }

  onFiltered(filteredItems) {
    this.currentPage = 1;
    this.totalRows = filteredItems.length;
  }

  get sortDesc(): boolean {
    return this.sortOrderProp === 'desc';
  }

  set sortDesc(value) {
    this.sortOrderProp = value ? 'desc' : 'asc';
  }
}
